
export class ForgotPassword   {
	public usernameOrEmail: string;
}